import React, { useState } from 'react';
import { useNIR } from "../../hooks/useNIR";
import {Select, Spin, Typography} from "antd";
import { Content } from "antd/es/layout/layout";
import { Bar } from "@ant-design/plots";
import html2canvas from "html2canvas";
import {CALCULATED_FUNCTIONS, COUNTRIES} from "../../utils/consts";

export const DemoBarNIR = () => {
	const { data, calculatedData, loading, setData, calculatedFunction, setCalculatedFunction } = useNIR();
	// const [isNir, setIsNir] = useState<boolean>(false);

	const [countries, setCountries] = useState<string[]>(["USA"]);
	const handleDownload = () => {
		const chartContainer = document.getElementById('chart-container');
		if (chartContainer) {
			html2canvas(chartContainer, {
				scale: 2, // Increase scale for higher resolution
				useCORS: true, // Ensure cross-origin images are rendered properly
				allowTaint: true, // Allow tainted images
			}).then((canvas) => {
				const link = document.createElement('a');
				link.download = 'chart.png';
				link.href = canvas.toDataURL('image/png', 1.0); // Use maximum quality
				link.click();
			});
		}
	};

	const config = {
		data: calculatedData && calculatedData?.length > 0 && calculatedData,
		xField: 'element',
		yField: 'percent',
		stack: true,
		colorField: "type",
		grid: true,
		sort: {
			reverse: true,
			by: 'y',
		},
		axis: {
			y: {
				labelFormatter: '~s',
				labelFontSize: 14,
				labelSpacing: 6,
				labelFill: "black",
				labelFillOpacity: 1,
				color: "#000000",
				gridAreaFill: "rgba(0,0,0,0.05)",
				grid: true,
				line: true,
				style: {
					color: "#000000",
					labelTransform: 'rotate(0)',
				}
			},
			x: {
				labelFill: "black",
				line: true,
				grid: true,
				color: "#000000",
				labelSpacing: 6,
				labelFontSize: 16,
				labelFillOpacity: 1,
			},
		},
	};

	// const nirConfig = {
	// 	data: data.nirData && data.nirData?.length > 0 && data.nirData,
	// 	xField: 'chemicalElement',
	// 	yField: 'NIR',
	// 	stack: true,
	// 	colorField: "NIR",
	// 	sort: {
	// 		reverse: true,
	// 		by: 'y',
	// 	},
	// 	axis: {
	// 		y: { labelFormatter: '~s' },
	// 		x: {
	// 			labelSpacing: 4,
	// 			style: {
	// 				labelTransform: 'rotate(90)',
	// 			},
	// 		},
	// 	},
	// };

	return (
		<Content
			style={{
				padding: '0 24px',
				height: '100%',
				display: "flex",
				flexDirection: "column",
				overflow: 'scroll',
			}}
		>

			<h1 style={{ color: 'var(--navy)', fontSize: '28px', fontWeight: 700, margin: '24px 0 16px', width: '100%', textAlign: 'left' }}>Net Import Reliance</h1>

			{/* Controls panel */}
			<div className="va-controls-panel">
				<div className="va-control-group">
					<span className="va-control-label">Calculated Function</span>
					<Select
						value={calculatedFunction}
						onChange={(value) => {
							console.log(value);
							setCalculatedFunction(value);
						}}
						options={CALCULATED_FUNCTIONS.map((item) => ({
							value: item,
							label: item
						}))}
					/>
				</div>
				<div className="va-control-group">
					<span className="va-control-label">Countries</span>
					<Select
						mode={"multiple"}
						className={"select"}
						value={countries}
						disabled={true}
						options={COUNTRIES}
						onChange={(value) => {
							setCountries(value);
						}}
					/>
				</div>
				<div className="va-control-group" style={{marginLeft: "auto"}}>
					<button
						className="data-btn"
						onClick={handleDownload}
					>
						Download Chart as PNG
					</button>
				</div>
			</div>

			{/* Chart */}
			<Spin spinning={loading} size="large" style={{width: '100%'}}>
			<div className="chart-frame" id="chart-container" style={{ maxHeight: '72vh', overflow: 'auto' }}>
				{calculatedData && calculatedData?.length > 0 && (
					<Bar
						{...config}
						containerStyle={{ width: "100%", height: `${Math.max(400, (calculatedData.length / 3) * 36)}px` }}
					/>
				)}
			</div>
			</Spin>
		</Content>
	);
};
